<template>
  <div class="container">
    <!-- <div class="title">
      帳戶與安全
    </div> -->
    <div class="all-account">
      <div class="account-message phone-number">
        <div class="col1">手機号登入</div>
        <div class="col-wrap">
          <div class="col4">手機號碼</div>
          <div v-if="accountObj.phoneNumber" class="col2">+{{ accountObj.phoneNumber }}</div>
          <div v-else class="col2 text-red">建議綁定手機號碼提升帳戶安全等級</div>
          <div class="col3">
            <button v-if="accountObj.phoneNumber" class="blue-btn tobind" @click="handlePhoneNumber(true)">更换</button>
            <button v-else class="tobind" @click="handlePhoneNumber(false)">去綁定</button>
          </div>
        </div>
      </div>
      <div class="account-message thirdpary-wrap">
        <div class="col1">社交账户</div>
        <div class="col-wrap">
          <div
            v-for="item in accounts"
            :key="item.name"
            class="one-thirdpary"
          >
            <div class="col4">{{ item.name }}</div>
            <div class="col2">{{ accountObj[item.objName] ? (accountObj[item.objName] === 'unknown' ? '已綁定' : accountObj[item.objName]) : '' }}</div>
            <div class="col3">
              <button v-if="accountObj[item.objName]" @click="verify(item.name, false)">解除綁定</button>
              <button v-else class="tobind" @click="verify(item.name, true)">去綁定</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      class="salety-dialog"
      :visible.sync="showBindPhone"
      :show-close="false"
      :close-on-click-modal="false"
      append-to-body
    >
      <slot name="title">
        <div class="dialong-title">
          {{ isBindPhone ? '綁定手機號' : '修改手機號' }}
          <fps-icon class="close-dialog pointer" type="close" @click.native="showBindPhone=false" />
        </div>
      </slot>
      <div class="login-body">
        <div v-show="firstStep" class="insure-you">為了確保是您本人，請先確認手機號</div>
        <div class="row-container">
          <label v-show="firstStep">原手機號</label>
          <div
            v-if="firstStep"
            class="old-phone-number"
          >
            +{{ accountObj.phoneNumber }}
          </div>
          <div v-else class="login-body-line">
            <div class="mobile-prefix">
              <el-popover
                v-model="isShowMobileAreaSelectList"
                :visible-arrow="false"
                class="popper-clear-style-wrap"
                popper-class="popper-clear-style"
                placement="bottom-start"
              >
                <div slot="reference" class="mobile-prefix-inner">
                  <span>{{ currentSelectPrefix.code }}</span>
                  <img src="~@/assets/images/select-icon.png" alt="" />
                </div>
                <div
                  class="login-body-mobile-area"
                  v-clickoutside="closeMobileAreaSelectList"
                >
                  <p
                    v-for="(item, index) in mobileAreaList"
                    :key="index"
                    @click="selectMobileArea(item.code)"
                  >
                    <span>{{ item.text }}</span>
                    <span>{{ item.code }}</span>
                  </p>
                </div>
              </el-popover>
            </div>
            <div class="mobile-input">
              <input
                v-model="loginObj.phoneNumber"
                id="mobile-input"
                type="text"
                placeholder="請輸入手機號碼"
              />
            </div>
            <div
              v-show="showErrorMessage"
              class="error-message"
            >
              手機號已被綁定
            </div>
          </div>
        </div>
        <div class="row-container code">
          <!-- <label for="verifica-code">認證碼</label> -->
          <div class="login-body-line">
            <div class="valid-code">
              <input
                v-model="loginObj.verifyCode"
                id="verifica-code"
                type="text"
                placeholder="請輸入認證碼"
              />
            </div>
            <div class="btn">
              <button @click="getValidateCode">
                <span v-if="isSendingSmsCode">
                  <i class="el-icon-loading"></i>
                  發送中
                </span>
                <span v-else>{{
                  sendCodeTimer > 0
                    ? sendCodeTimer + "s"
                    : "獲取認證碼"
                }}</span>
              </button>
            </div>
            </div>
          </div>
      </div>
      <div
        class="affirm-btn-wrap"
        @click="verifyCode"
      >
        <button :disabled="disabled">{{ firstStep ? '下一步' : '提交' }}</button>
      </div>
    </el-dialog>
    <div id="verification-code"></div>
  </div>
</template>

<script>
import mobileAreaList from '@/utils/areas-code'
import Clickoutside from "@/utils/clickoutside"
import { getSmsCode } from "@/api"

export default {
  name: 'Salety',
  directives: {
    clickoutside: Clickoutside
  },
  data() {
    return {
      accounts: [{
        name: 'Facebook',
        objName: 'facebookInfo'
      },{
        name: 'Google',
        objName: 'googleInfo'
      },{
        name: 'Line',
        objName: 'lineInfo'
      }],
      accountObj: {},
      mobileAreaList: mobileAreaList,
      loginObj: {
        phoneNumber: "",
        verifyCode: "",
        keyUuid: null
      },
      isSendingSmsCode: false,
      sendCodeTimer: 0,
      currentSelectPrefix: {
        code: 886
      },
      isShowMobileAreaSelectList: false,
      showBindPhone: false,
      tencentCaptchaInstance: null,
      isVerifying: false,
      firstStep: false,
      showErrorMessage: false
    }
  },
  computed: {
    isBindPhone() {
      return !this.accountObj.phoneNumber
    },
    disabled() {
      return (this.firstStep ? (!this.accountObj.phoneNumber && !this.loginObj.phoneNumber) : !this.loginObj.phoneNumber) || !this.loginObj.verifyCode
    }
  },
  watch: {
    showBindPhone(value) {
      if(!value) this.firstStep = true
      this.$set(this.currentSelectPrefix, 'code', 886)
      this.showErrorMessage = false
    },
    firstStep() {
      if (this.codeTimerHandler) {
        clearTimeout(this.codeTimerHandler)
        this.codeTimerHandler = null
        this.sendCodeTimer = 0
      }
      this.loginObj = {
        phoneNumber: "",
        verifyCode: "",
        keyUuid: null
      }
      this.tencentCaptchaInstance = null
    },
    accountObj(value) {
      if (value.phoneNumber) {
        this.$emit('closeShowLowSafe')
      }
    }
  },
  created() {
    this.isBinding = true
    this.providers = {}
    this.getThirdInfo()
    this.checkLineLogin()
  },
  methods: {
    async getThirdInfo() {
      try {
        let rs = await this.$http.get('/user/login/info')
        this.accountObj = rs.data
        this.isBinding = false
      } catch (e) {
        this.$message.error('網絡異常')
      }
    },
    checkLineLogin() {
      let code = sessionStorage.getItem('lineParams')
      if (code) {
        sessionStorage.removeItem('lineParams')
        this.$http.post('/login/line/token', {
          grant_type: 'authorization_code',
          callback_url: location.origin,
          code
        }).then(rs => {
          let lineToken = rs.data.id_token
          this.$http.post('/login/line/add',{
            lineToken,
            loginChannelKind: 'Line'
          }).then(rs => {
            this.$message({
              type: 'success',
              message: '綁定成功'
            })
            this.$set(this.accountObj, 'lineInfo', rs.data)
          }).catch(rs => {
            if (rs.code === 432) {
              this.$message.error('您要綁定的第三方帳號已註冊，請更換其他帳號')
              return
            }  
            this.$message.error('綁定失敗')
          })
        }).catch(() => {
          this.$message.error('認證失敗')
        })
      }
    },
    getState() {
      let nums = Math.floor(Math.random() * 7 + 10)
      let rs = ''
      for(let i = 0; i < nums; i++) {
        rs += Math.floor(Math.random() * 36).toString(36)
      }
      window.sessionStorage.setItem('LineState', rs)
      return rs
    },
    async verify(name, bind) {
      if (this.isBinding) return
      this.isBinding = true
      if (!this.accountObj.phoneNumber) {
        try {
          await this.$confirm({
            content: `請先綁定手機號，再${ bind ? '綁定' : '解除綁定' } ${name}`,
            confirmButtonText: '去綁定',
            cancelButtonText: '再想想',
            closeOnClickModal: false,
            closeOnPressEscape: false,
          })
          this.handlePhoneNumber(false)
        } catch(e) {
          console.log(e)
        }
        this.isBinding = false
        return
      }
      if (!bind) {
        try {
          await this.$confirm({
            content: `確認解除綁定 ${name}？`,
            confirmButtonText: '再想想',
            cancelButtonText: '確認解除',
            closeOnClickModal: false,
            closeOnPressEscape: false,
          })
          this.isBinding = false
        } catch(e) {
          let urlBase = 'firebase'
          let data = {
            loginChannelKind: name
          }
          if (name === 'Line') {
            urlBase = 'line'
            data = null
          }
          this.$http.post(`/login/${urlBase}/cancel`,data).then(() => {
            this.isBinding = false
            this.$message({
              type: 'success',
              message: '解綁成功'
            })
            this.$set(this.accountObj, name.toLowerCase() + 'Info', '')
          }).catch(() => {
            this.$message.error('解綁失敗，請重試')
          })
        } 
        return
      }
      if (!this.providers[name]) {
        switch(name) {
          case 'Facebook': {
            this.providers[name] = new window.firebase.auth.FacebookAuthProvider()
            break
          }
          case 'Google': {
            this.providers[name] = new window.firebase.auth.GoogleAuthProvider()
            break
          }
          case 'Line': {
            // sessionStorage.setItem('beforeJump2LoginLine_pagelogin', 1)
            sessionStorage.setItem('beforeJump2LoginLine', location.href)
            location.href = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${window.lineChannelId}&redirect_uri=${encodeURIComponent(location.origin)}&scope=openid%20profile&state=${this.getState()}`
            return
          }
        }
      }
      window.firebase.auth().signInWithPopup(this.providers[name]).then(rs => {
        let token = rs.user._lat
        this.$http.post('/login/firebase/add', {
          firebaseToken: token,
          loginChannelKind: name
        }).then(rs => {
          this.isBinding = false
          this.$message({
            type: 'success',
            message: '綁定成功'
          })
          this.$set(this.accountObj, this.accounts.find(rs => rs.name === name).objName, rs.data)
        }).catch(rs => {
          this.isBinding = false
          if (rs.code === 432) {
            this.$message.error('您要綁定的第三方帳號已註冊，請更換其他帳號')
            return
          }
          this.$message.error('認證失敗')
        })
      }).catch(() => {
        this.isBinding = false
        this.$message.error('認證失敗')
      })
    },
    async verifyCode() {
      this.showErrorMessage = false
      const params = this.validateInputMsg()
      if (params && !this.isVerifying) {
        if (!this.firstStep && (this.currentSelectPrefix.code + this.loginObj.phoneNumber) === this.accountObj.phoneNumber) {
          this.showErrorMessage = true
          return
        }
        this.isVerifying = true
        let url = ''
        if (this.isBindPhone) {
          url = '/user/telephone/bind'
        } else {
          if (this.firstStep) {
            url = '/user/telephone/sms/verify'
          } else {
            url = '/user/telephone'
          }
        }
        this.$http.post(url, params).then(rs => {
          this.isVerifying = false
          if (this.firstStep) {
            this.firstStep = false
          } else {
            this.$message({
              type: 'success',
              message: this.isBindPhone ? '綁定成功' : '修改成功'
            })
            if (this.isBindPhone) {
              this.$store.dispatch('app/setUserInfo', {
                userInfo: rs.data,
              })
            }
            this.showBindPhone = false
            this.$set(this.accountObj, 'phoneNumber', params.phoneNumber)
          }
        }).catch(rs => {
          this.isVerifying = false
          if (rs.code === 434) {
            this.showErrorMessage = true
            return
          }
          if (rs.code === 618) {
            this.$message.error('驗證碼錯誤')
          } else {
            this.$message.error('網絡異常')
          }
        })
      }
    },
    toggleMobileAreaSelectList() {
      this.isShowMobileAreaSelectList = !this.isShowMobileAreaSelectList
    },
    setSmsCodeInterval(count) {
      this.sendCodeTimer = count

      if (count > 0) {
        this.codeTimerHandler = setTimeout(this.setSmsCodeInterval.bind(this, --count), 1000)
      } else {
        this.codeTimerHandler = null
      }
    },
    /**
     * @description 校驗輸入輸入內容
     */
    validateInputMsg() {
      let { verifyCode, keyUuid } = this.loginObj
      let phoneNumber = ''
      if (this.firstStep) {
        phoneNumber = this.accountObj.phoneNumber
      } else {
        phoneNumber = this.loginObj.phoneNumber
      }

      if (!phoneNumber) {
        this.$message.error("手機號碼錯誤，請重新填寫")
        return false;
      }
      if (verifyCode.length !== 4) {
        this.$message.error("請輸入認證碼")
        return false;
      }
      if (!this.firstStep) {
        const { code } = this.currentSelectPrefix
        phoneNumber = code + phoneNumber
      }
      return {
        phoneNumber,
        verifyCode,
        keyUuid,
        isSaveToken: this.isKeepLoginStatus
      }
    },
    getValidateCode() {
      if (this.sendCodeTimer > 0) return
      let phoneNumber = ''
      if (this.firstStep) {
        phoneNumber = this.accountObj.phoneNumber
      } else {
        phoneNumber = this.loginObj.phoneNumber
      }
      if (!phoneNumber) return this.$message.error("請輸入手機號碼")
      if (!this.tencentCaptchaInstance) {
        this.tencentCaptchaInstance = new window.TencentCaptcha(document.querySelector('#verification-code'), process.env.VUE_APP_VERIFICATION_APPID, resp => {
          if (resp.ret === 0) {
            this.isSendingSmsCode = true
            let phoneNumber = ''
            if (this.firstStep) {
              phoneNumber = this.accountObj.phoneNumber
            } else {
              phoneNumber = this.currentSelectPrefix.code + this.loginObj.phoneNumber
            }
            getSmsCode({
              phoneNumber,
              ticket: resp.ticket,
              rand: resp.randstr
            }).then(({ data }) => {
              if (data) {
                this.loginObj.keyUuid = data
                this.setSmsCodeInterval(30)
              }
              this.isSendingSmsCode = false
            }).catch(err => {
              this.isSendingSmsCode = false
              if (err.msg) {
                if (err.msg === 'InvalidParameterValue.IncorrectPhoneNumber') {
                  this.$message.error('手機號格式錯誤')
                  return
                }
                this.$message.error(err.msg)
              }
            })
          }
        })
      }
      this.tencentCaptchaInstance.show()
    },
    closeMobileAreaSelectList() {
      this.$nextTick(() => {
        if (this.isShowMobileAreaSelectList) {
          this.isShowMobileAreaSelectList = false
        }
      })
    },
    selectMobileArea(code) {
      this.currentSelectPrefix.code = code
      this.closeMobileAreaSelectList()
    },
    handlePhoneNumber(flag) {
      this.firstStep = flag
      this.showBindPhone = true
    }
  }
}
</script>
<style lang="scss" scoped>
.text-red {
  font-size: 14px !important;
  color: $color-orange !important;
}
.container {
  height: 100%;
}
.title {
  color: #333;
  font-weight: 500;
  font-size: 22px;
  line-height: 31px;
  padding: 30px 40px;
  border-bottom: 2px solid #F4F4F4;
}
.all-account {
  padding: 16px 48px 10px;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  .account-message {
    display: flex;
    line-height: 70px;
    &.phone-number {
      border-bottom: 2px solid $color-split;
      .col-wrap {
        flex: 1;
        @include flex;
      }
    }
  }
  .col1 {
    width: 223px;
    font-weight: 500;
    font-size: 16px;
    color: #333;
    text-align: left;
  }
  .thirdpary-wrap {
    .col-wrap {
      flex: 1;
      display: flex;
      flex-direction: column;
      .one-thirdpary {
        width: 100%;
        @include flex;
        border-bottom: 1px solid $color-split;
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
  .col4 {
    width: 220px;
    font-size: 16px;
    color: $color-gray-1;
  }
  .col2 {
    flex: 1;
    font-size: 16px;
    color: $color-gray-3;
  }
  .col3 {
    width: 124px;
    font-size: 16px;
    line-height: 24px;
    text-align: right;
    button {
      height: 24px;
      border-radius: 4px;
      border: none;
      color: $color-gray-2;
      &:hover {
        text-decoration: underline;
      }
    }
    .tobind {
      font-weight: 500;
      color: $color-link;
    }
  }
}
.input-border {
  border-radius: 4px;
  border: 1px solid #999999;
  background: #fbfbfb;
}
.insure-you {
  color: #999;
  font-size: 14px;
  margin-bottom: 11px;
  line-height: 20px;
}
.row-container {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666;

  &.code {
    margin-top: 20px;
    .login-body-line {
      justify-content: space-between;
    }
  }
  label {
    width: 78px;
  }
  .login-body-line {
    flex: 1;
  }
}
.salety-dialog {
  & /deep/ .el-dialog {
    width: 418px;
    border-radius: 8px;
  }
  & /deep/ .el-dialog__body {
    padding: 0 !important;
  }
  & /deep/ .el-dialog__header {
    padding: 0 !important;
  }
}
.dialong-title {
  padding: 18px;
  color: black;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  border-bottom: 1px solid #E0E0E0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .close-dialog {
    font-size: 18px;
    color: $color-gray-3;
  }
}
.login-body {
  display: flex;
  padding: 10px 30px 0;
  flex-direction: column;
}
.affirm-btn-wrap {
  width: 100%;
  height: 90px;
  margin-top: 32px;
  @include flex(flex-end, center);

  button {
    @include flex();
    width: 128px;
    height: 40px;
    color: $color-gray-1;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    border-radius: 50px;
    cursor: pointer;
    background: $color-yellow;
    margin-right: 25px;
    &:disabled {
      background: $color-split !important;
      color: rgba(99, 109, 134, .3) !important;
    }
  }
}
.login-body-mobile-area {
  width: 290px;
  height: 228px;
  overflow: auto;
  border-radius: 4px;
  border: 1px solid #999;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

  p {
    @include flex(space-between);
    color: #333;
    font-size: 16px;
    height: 38px;
    margin: 0;
    padding: 0 9px;
    font-weight: 400;
    transition: all 0.2s ease;
    cursor: pointer;
    background: white;

    &:hover {
      background: #f6f6f6;
    }

    span:first-child {
      @include ellipsis;
    }
  }
}
.login-body {
  position: relative;
  // border-top: 1px solid #e0e0e0;
}
.login-body-line {
  position: relative;
  @include flex(flex-start);
  height: 40px;
  box-sizing: border-box;
  font-size: 16px;

  > div {
    @include flex();
    height: 100%;
  }

  input {
    width: 100%;
    height: 100%;
    color: #333;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
  }
  $mobile-prefix-width: 71px;
  @mixin inputBackgroud() {
    background: #F9F9F9;
    border-radius: 6px;
  }
  .mobile-prefix {
    width: $mobile-prefix-width;
    height: 44px;
    @include flex;
    @include inputBackgroud;
    flex-shrink: 0;
    cursor: pointer;

    .mobile-prefix-inner {
      width: $mobile-prefix-width;
      @include flex;
      span {
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        margin-right: 6px;
      }
    }

    img {
      width: 10px;
      margin-left: 2px;
    }
  }

  .mobile-input {
    flex-grow: 1;
    margin-left: 14px;
    padding-left: 14px;
    @include inputBackgroud;
    input{
      -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
      font-weight: 600;
      color: $color-gray-1;
      &::placeholder {
        font-weight: normal;
        color: $color-gray-3;
      }
    }
  }

  .valid-code {
    flex: 1;
    width: 164px;
    border-radius: 4px;
    padding: 0 13px;
    @include inputBackgroud;
    margin-right: 2px;
  }

  .btn {
    width: 100px;
    margin-left: 10px;

    button {
      @include flex();
      width: 100%;
      height: 100%;
      color: white;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      border-radius: 4px;
      box-sizing: border-box;
      border: 1px solid $color-gray-3;
      color: $color-gray-2;
      cursor: pointer;
    }
  }
}

.login-body-operation {
  display: inline-block;
  font-size: 0;
  margin-top: 40px;

  p {
    @include flex(flex-start);
    cursor: pointer;
  }

  img {
    width: 14px;
    height: 14px;
    margin-right: 6px;
  }

  span {
    font-size: 13px;
    color: #666;
    line-height: 18px;
  }
}
.error-message {
  position: absolute;
  font-size: 12px;
  line-height: 20px;
  bottom: -30px;
  color: #FE1717;
  left: 0;
}

</style>
